import { useSheetContext } from "./SheetContext.mjs";
const useSheet = () => useSheetContext("", void 0);
export { useSheet };
//# sourceMappingURL=useSheet.mjs.map
